import * as React from 'react';
import { BeneficiaryDetailForm } from "./BeneficiaryDetailForm";

interface AddBeneficiaryProps {
    emitHandleAddBeneficiary: any;
    emitHandleBack: any;
    beneficiaryForm: any;
    beneficiary: any;
    emitHandleSave: any;
    emitHandleChange: any;
}

export class AddBeneficiary extends React.Component<AddBeneficiaryProps, any> {

    constructor(props) {
        super(props);
        this.state = {
            updateReminderDismissed: false,
            selectedBenefit: {},
            isInEdit: false,
            beneficiaryForm: { ...this.props.beneficiaryForm },
            beneficiary: {
              ...this.props.beneficiary,  
            },
        }

        this.handleAddBeneficiary = this.handleAddBeneficiary.bind(this);
        this.handleBack = this.handleBack.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSave = this.handleSave.bind(this);
    }
    
    handleAddBeneficiary(e) {
        this.props.emitHandleAddBeneficiary();
    }
    
    handleBack() {
        this.props.emitHandleBack();
    }
    
    handleChange(key, val) {
        this.props.emitHandleChange(key, val);
    }
    
    handleSave() {
        this.props.emitHandleSave(this.props.beneficiary);
    }

    public render() {
        const beneficiaryForm = { ...this.props.beneficiaryForm };
        const beneficiary = { ...this.props.beneficiary };
        
        return (
            <BeneficiaryDetailForm 
                emitHandleChange={this.handleChange}
                title={"Add beneficiary details"}
                subtitle={`Please add your beneficiary's personal details below`}
                beneficiary={beneficiary}
                beneficiaryForm={beneficiaryForm}
                emitHandleUpdate={this.handleSave}
            />
        )
    }

}